import React, { useState, useEffect } from "react";
import { t } from "i18next";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { PageHeaderV2 } from "components/PageHeader";
import { CustomButton } from "components/Button";
import { PriceRender } from "components/DisplayPrice";
import OrderStatusTag from "components/order/OrderStatusTag";
import WithLoading from "components/Hoc/WithLoading";
import { useCustomHistory } from "hooks";
import useQueryParam from "../hooks/useQueryParam";
 
const TextContent = ({ title, value, isPrice }) => {
  return (
    <div className="flex justify-between">
      <p className="text-16x text-dark-blue-900 font-medium">{title}</p>
      {isPrice ? (
        <PriceRender className="text-16x text-dark-blue-900 font-medium leading-none" price={+value} />
      ) : (
        <p className="text-16x text-dark-blue-900 font-medium capitalize">{value}</p>
      )}
    </div>
  );
};

export const OrderSummary = ({ order }) => {
  if (!order || !order._id) return null;

  const orderDate = moment.unix(order.orderPlacedTime).format("MMMM D, YYYY — HH:mm");

  return (
    <div className="p-6 mt-3 w-full">
      <div className="text-12x text-shadow-forge-700 font-medium ">{orderDate}</div>
      <h1 className="m-0 text-28x text-shadow-forge-900 font-semibold ">
        {t("Thanks For Ordering")}
      </h1>
      {/* <CustomButton outline className="w-fit border-dashed mt-3 mb-4" disabled={true}>
        {t("Reorder")}
      </CustomButton> */}

      <div
        className="p-6 mt-13"
        style={{
          background: "#F9FAFB",
          border: "1px solid #E5E7EB",
          borderTopLeftRadius: "24px",
          borderTopRightRadius: "24px",
        }}
      >
        <h2 className="text-20x font-semibold text-dark-blue-900 pt2">
          {t("Order Details")}
        </h2>

        <TextContent title={t("Order Number")} value={`#${order.orderNumber}`} />
        <div className="flex justify-between">
          <p className="text-16x text-dark-blue-900 font-medium">{t("Status")}</p>
          <OrderStatusTag status={order.orderStatus} />
        </div>
        {order.isPreOrder && order.preOrder?.preOrderSlotStartTime ? (
          <TextContent
            title={t("Pre Order Slot")}
            value={`${moment
              .unix(order.preOrder.preOrderSlotStartTime)
              .format("MMM D, YYYY")}, ${moment
              .unix(order.preOrder.preOrderSlotStartTime)
              .format("hh:mm A")} - ${moment
              .unix(order.preOrder.preOrderSlotEndTime)
              .format("hh:mm A")}`}
          />
        ) : null}

        <div className="mt-4 space-y-2">
          {order.orderedMenu?.map((item) => (
            <TextContent
              key={item._id}
              title={t(`${item.quantity}x ${item.baseLanguage.title}`)}
              value={item?.price * item?.quantity}
              isPrice
            />
          ))}
        </div>

        <div className="border-t pt-4 space-y-1 text-dark-blue-900 mt-4">
          <TextContent title={t("Subtotal")} value={order.itemsTotalPrice} isPrice />
          {order.taxRate > 0 && <TextContent title={t("vat with value", {
            taxRate: order.taxRate || 0
          })} value={((order.taxRate/100) * (order.itemsTotalPrice + order.deliveryFee)) || 0} isPrice />
          }
          <TextContent title={t("Value Added Tip")} value={order.tipAmount || 0} isPrice />
          <TextContent
            title={t("Voucher Discount")}
            value={order.voucherDiscount ? `${order.voucherDiscount}% ${t("off")}` : t("N/A")}
          />
          <TextContent title={ order.taxRate === 0 ? t("Total (VAT Inc.)") : t("Total")} value={order.totalOrderPrice} isPrice />
        </div>

        <div className="border-t pt-4 space-y-1 text-dark-blue-900 mt-4">
          <TextContent title={t("Payment Method")} value={order.paymentType?.replaceAll("_", " ")?.toLowerCase()} />
        </div>
      </div>
    </div>
  );
};

function OrderDetail(props) {
  const params = useParams();
  const history = useHistory();
  const router = useCustomHistory();
  const queryParam = useQueryParam();

  const [order, setOrder] = useState({});
  const { DomainType } = useSelector((state) => state.AppReducer);


  const goBack = () => {
    router(
      `/dine-in/my-orders`,
      `/${params.domainName}/dine-in/my-orders`,
      DomainType,
      null,
      `?${queryParam}`
    );
  };
  useEffect(() => {
    if (history?.location?.state?.order) {
      const { order } = history?.location?.state;
      setOrder(order);
    } else {
      router(
        `/dine-in/`,
        `/${params.domainName}/dine-in/`,
        DomainType,
        null,
        `?${queryParam}`
      );
    }
  }, []);

  return (
    <WithLoading>
      <div>
        <PageHeaderV2
          containerStyleProps={{
            style: {
              zIndex: 100,
            },
          }}
          headerStyleProps={{
            className: "p-6",
          }}
          pageTitle={"Order Details"}
          onGoBack={goBack}
          hideAuth={true}
        />
        <br />
        <br />
        <br />
        <OrderSummary order={order} />
      </div>
    </WithLoading>
  );
}

export default OrderDetail;
